import styled from "styled-components";

export const StyledPost = styled.div`
	.post {
		padding: 20px;
		width: 520px;
		background-color: var(--color-brand-2);
		border-radius: 5px;

		.user-info {
			display: flex;
			justify-content: space-between;
			align-items: center;
			column-gap: 1rem;

			.infos {
				display: flex;
				align-items: center;
				column-gap: 1rem;

				a img {
					width: 50px;
					height: 50px;
					border-radius: 50%;
					background-color: var(--color-white-fixed);
					box-shadow: 0px 2px 3px var(--color-gray-0);
				}

				.info-name {
					font-weight: 600;
					font-size: 1.4rem;
				}

				.info-username {
					font-size: 1.2rem;
					display: flex;
					align-items: center;

					img {
						width: 13px;
					}
				}

				.info-posted-at {
					font-size: 1.1rem;
					color: var(--color-gray-6);
				}
			}
		}

		.post-body {
			padding: 2rem 0;
			display: flex;
			flex-direction: column;
			row-gap: 16px;

			.message {
				text-align: justify;
			}

			.images {
				img {
					width: 100%;
					max-width: 100%;
					max-height: 100%;
					border-radius: 5px;
					box-shadow: 1px 2px 5px var(--color-gray-0);
				}
				.text {
					color: var(--color-gray-3);

					span {
						font-style: italic;
					}
				}
			}
		}

		.interact {
			width: 100%;
			display: flex;
			column-gap: 1.2rem;

			> abbr:last-child {
				margin-right: 0;
				margin-left: auto;
			}
		}
	}

	@media screen and (max-width: 460px) {
		.post {
			max-width: 350px;
		}
	}
`;
